import React from "react";
import { Styled } from "../styles";
import { Box, Link, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useModal } from "../context";
import constant from "@/utils/constant";
import { onHandleLink } from "@/utils/helpers";

const Links: React.FC = () => {
    const eid = useModal(state => state.product?.eid);

    const link =
        constant.DEV || constant.STAGING
            ? `https://info-staging.dippi.app/p/${eid}`
            : `https://info.dippi.app/p/${eid}`;

    return (
        <Styled.Body>
            <Box display="flex" alignItems="flex-start" flexDirection="column" gap={2}>
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography>EU compliant link:</Typography>
                    <Link
                        data-testid="eu-link"
                        href={link + "?v=1"}
                        underline="none"
                        target="_blank"
                        rel="noreferrer noopener"
                    >
                        <Typography>{link.replace("https://", "") + "?v=1"}</Typography>
                    </Link>
                    <ContentCopyIcon
                        onClick={onHandleLink.bind(this, "copy-eucompliant", eid!)}
                        sx={{ width: 18, height: 18, cursor: "pointer" }}
                    />
                </Box>
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography>Marketing link:</Typography>
                    <Link href={link} underline="none" target="_blank" rel="noreferrer noopener">
                        <Typography>{link.replace("https://", "")}</Typography>
                    </Link>
                    <ContentCopyIcon
                        onClick={onHandleLink.bind(this, "copy-marketing", eid!)}
                        sx={{ width: 18, height: 18, cursor: "pointer" }}
                    />
                </Box>
            </Box>
        </Styled.Body>
    );
};

export default Links;
